import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GatewayRoutingModule } from './gateway-routing.module';
import { GatewayListComponent } from './components/gateway-list/gateway-list.component';
import { GatewayLeftPanelComponent } from './components/gateway-left-panel/gateway-left-panel.component';
import { GatewayMainPanelComponent } from './components/gateway-main-panel/gateway-main-panel.component';
import { GatewayLogsComponent } from './components/gateway-logs/gateway-logs.component';
import { AddGatewayComponent } from './modals/add-gateway/add-gateway.component';
import { UpdateGatewayComponent } from './modals/update-gateway/update-gateway.component';
import { DeleteGatewayComponent } from './modals/delete-gateway/delete-gateway.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from '../../app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AngularMaterialModule } from '../../shared/material-module';
import { NgxPaginationModule } from 'ngx-pagination';
import { ResizableModule } from '../../core/directive/resizable/resizable.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    GatewayListComponent,
    GatewayLeftPanelComponent,
    GatewayMainPanelComponent,
    GatewayLogsComponent,
    AddGatewayComponent,
    UpdateGatewayComponent,
    DeleteGatewayComponent
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    GatewayRoutingModule,
    NgxSpinnerModule,
    BrowserModule,
    FormsModule,
    CoreModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    NgxPaginationModule,
    ResizableModule,
    NgbModule,
  ]
})
export class GatewayModule { }
